export const svg = (color, strokeColor) => ({
  "path, circle, rect": {
    fill: color,
    transition: " fill 0.3s, stroke 0.3s",

    "&[stroke]": {
      fill: "none",
      stroke: strokeColor || color,

      "&[fill]": {
        fill: color,
      },
    },
  },
});
